import {dataMember, required} from 'santee-dcts';

export class CoordinatorEQueryEscalation {
    @dataMember()
    @required()
    public escalationId: number;

    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required()
    public emailAddress: string;
}